class ProductGroup {
  constructor(data){
    this.id = data.id;
    this.name = data.name;
    this.pageUrl = data.pageUrl;
    this.imageUrl = data.imageUrl;
    this.position = data.position;
    // this.productIds = data.products.map(x => x.id); // Flat.  For fast lookups.  But not used at present.
    // Add calculated (~virtual) property.  Up-front so will be watched reliably.
    this.filteredProductIds = [];
  }

  static all(data) {
    let productGroups = [];

    for (let productGroupData of data) {
      productGroups.push(new ProductGroup(productGroupData))
    }

    return productGroups;
  }

  static group(allProductGroups, products) {
    // Return a collection of unique product groups, with each's filteredProductIds populated.
    let productGroups = [];

    for (let product of products) {
      let productGroup = allProductGroups.find(x => x.id == product.productGroupId);
      if (!productGroups.includes(productGroup)) {
        productGroups.push(productGroup);
        productGroup.filteredProductIds = [];
      }
      productGroup.filteredProductIds.push(product.id);
    }

    return productGroups;
  }

  key() {
    return `product_group_filtered_${this.id}`
  }
}

export default ProductGroup;
